import React from 'react'
import ProductSupermarketCommentContainer from '../../../../Components/Comments/ProductSupermarketCommentContainer/ProductSupermarketCommentContainer'
import Layout from '../../Layout'

const ProductSupermarketComment = () => {
  return (
    <Layout>
        <ProductSupermarketCommentContainer/>
    </Layout>
  )
}

export default ProductSupermarketComment